import React, {FormEvent} from "react";
import '../../../styles/components/onboarding/create-account/create-account-page.scss';
import {navigate} from "../../../services/navigation/navigation";
import {appPagePaths, onboardingImagesSource,} from "../../../config/config";
import Button from "../../common/Button";
import Form from "../../common/Form";
import onboarding from "../../../services/onboarding/onboarding";
import OrientationWebpImg from "../../common/OrientationWebpImg";
import ExternalLink from "../../common/ExternalLink";
import {WhenDeviceIOS} from "../../conditional/device/os/WhenDeviceIOS";
import {useMicrophone} from "../../../hooks/microphone.hook";
import {baseUrlForWebsite} from "../../../client/PlaygroundSettings";
import {FormFieldTextInput} from "../../common/FormFieldTextInput";

export default function CreateAccountPage() {
  const microphone = useMicrophone();

  const createAccountForm = onboarding.getCreateAccountForm();
  const isLoading = onboarding.useCreateAccountLoadingHook().isLoading;
  const {password, email} = createAccountForm;
  function handleSubmit(e: FormEvent){
    if(!isLoading){
      void onboarding.createAccountUsingCreateAccountForm(microphone.isAvailable);
    }
    e.preventDefault();
  }
  const signInButton = createSignInButton(microphone.isAvailable);
  return (
    <div className="create-account-page">
      <header className="top">
        <OrientationWebpImg srcPortrait={onboardingImagesSource.womanAtKeyboardPortrait} srcLandscape={onboardingImagesSource.womanAtKeyboardLandscape}/>
        <div className="overlay-text">
          <h1>Create an account</h1>
          <WhenDeviceIOS>
            <p className="trial-callout">14-day free trial</p>
          </WhenDeviceIOS>
        </div>
      </header>
      <div className={"content-and-navigation"}>
        <div className="content">
          <h1 className="page-header-text">Create an account</h1>
          <WhenDeviceIOS>
            <p className="trial-callout">14-day free trial</p>
          </WhenDeviceIOS>
          <Form onSubmit={handleSubmit}>
            <FormFieldTextInput
              label={"Email address"}
              autoComplete={"email"}
              isRequired={true}
              formField={email}
              isEmail={true}
            />
            <FormFieldTextInput
              label={"Password"}
              note={"Passwords must contain at least 8 characters."}
              autoComplete={"new-password"}
              isRequired={true}
              formField={password}
              isPassword={true}
            />
            <Button
              isLoading={isLoading}
              buttonType={"secondary"}
              text="Create Account"
              onClick={() => {}}
            />

          </Form>
          <div className="terms">
            By creating an account, you are agreeing to our&nbsp;
            <ExternalLink url={`${baseUrlForWebsite}/about/terms-and-conditions`}
              title={"Terms of Use"}/>,&nbsp;
            <ExternalLink url={`${baseUrlForWebsite}/about/privacy-policy`}
              title={"Privacy Policy"}/>,&nbsp;
            <ExternalLink url={`${baseUrlForWebsite}/about/license-agreement`}
              title={"License Agreement"}/>
          </div>
        </div>
        <div className="navigation">
          {signInButton}
        </div>
      </div>
    </div>
  );
}

function createSignInButton(isMicrophoneAvailable: boolean){
  const redirectTo = isMicrophoneAvailable
    ? appPagePaths.onboarding_setupFeedback_setupFeedbackAndScoring
    : appPagePaths.setupYourKeyboardPage;
  return <div className="text-and-button">
    <div className="text">Already have an account?</div>
    <Button text="Sign In" buttonType={"primary"} onClick={()=>{navigate(`${appPagePaths.signIn}?route-to-page-after-sign-in=${redirectTo}`)}}/>
  </div>
}